import { Link } from 'react-router';
import { useContact } from '@/features/settings/useSiteSettings';

export const ClosingCta = () => {
  const contact = useContact();

  return (
    <section aria-labelledby="zaro-cim" className="bg-sand-soft py-16 text-center sm:py-20">
      <div className="mx-auto w-full max-w-[1220px] px-4 sm:px-6">
        <img src="/kepek/otthon-gyogyulni.webp" alt="Mert otthon a legjobb gyógyulni." width={420} height={280} loading="lazy" className="mx-auto mb-8 w-full max-w-[320px]" />

        <h2 id="zaro-cim" className="text-2xl">
          Érdeklődjön most
        </h2>

        <p className="mx-auto mt-3 max-w-[52ch] text-ink-soft">Mi gyorsan házhoz visszük a megoldást, hogy Ön a fontos dolgokra összpontosíthasson.</p>

        <a href={contact.phoneHref} className="mt-7 inline-flex min-h-14 items-center font-display text-3xl font-bold text-navy no-underline hover:text-teal-ink">
          {contact.phone}
        </a>

        <p className="mt-3 text-sm text-ink-soft">
          {contact.weekdayHours}, {contact.weekendHours}
        </p>

        <div className="mt-7 flex flex-wrap justify-center gap-3">
          <Link to="/rendeles" className="inline-flex min-h-14 items-center rounded-md border-2 border-navy bg-navy px-7 font-semibold text-cream no-underline hover:bg-navy-deep">
            Bérlési igény leadása
          </Link>
          <a href="#szallitas" className="inline-flex min-h-14 items-center rounded-md border-2 border-navy px-7 font-semibold text-navy no-underline hover:bg-navy hover:text-cream">
            Szállítási díj kiszámítása
          </a>
        </div>
      </div>
    </section>
  );
};
